import { render, staticRenderFns } from "./download-pdf.vue?vue&type=template&id=99afb070&scoped=true&"
import script from "./download-pdf.vue?vue&type=script&lang=js&"
export * from "./download-pdf.vue?vue&type=script&lang=js&"
import style0 from "./download-pdf.vue?vue&type=style&index=0&id=99afb070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99afb070",
  null
  
)

export default component.exports